import React, { useEffect, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap';
import SelectDropdown from '../../common/utils/select-dropdown';

const LeadForm = ({ data, setData, noteData, setNoteData, properties, states, cities, getCityByState, inputError, setInputError }) => {

  function handleChange(e) {
    let { id, value } = e.target;
    if (id === 'state') {
      getCityByState(value);
    }

    setInputError({ ...inputError, [id]: '' });
    setData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  const filteredProperties = properties && properties.filter((property) => property.type === data.propertyType);

  return (
    <div className='row'>
      <div className='py-3'>
        <h6>Lead Information</h6>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="name">
          <Form.Label>Lead Name *</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter full name"
            onChange={handleChange}
            className={inputError && inputError.name ? 'border-danger' : ''}
            value={data && data.name}
            isInvalid={inputError && inputError.name}
          />
          <Form.Control.Feedback type="invalid">{inputError && inputError.name}</Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="type">
          <Form.Label>Lead Type *</Form.Label>
          <SelectDropdown
            searchable={false}
            options={[
              { name: "Person", value: "Person" },
              { name: "Organization", value: "Organization" }
            ]}
            labelField="name"
            valueField="value"
            placeholder="Please Select"
            selectedValue={data && data.type}
            onSelect={(value) => setData({ ...data, type: value })}
            menuClass="shadow"
          />
          <Form.Control.Feedback type="invalid">{inputError && inputError.name}</Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="phoneNumber">
          <Form.Label>Phone Number *</Form.Label>
          <InputGroup>
            <InputGroup.Text>+91</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="90XXXXXXXX"
              onChange={handleChange}
              className={inputError && inputError.phoneNumber ? 'border-danger border-left-0' : 'border-left-0'}
              value={data && data.phoneNumber}
              isInvalid={inputError && inputError.phoneNumber}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.phoneNumber}</Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="altPhoneNumber">
          <Form.Label>Alternate Phone Number</Form.Label>
          <InputGroup>
            <InputGroup.Text>+91</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="90XXXXXXXX"
              className='border-left-0'
              onChange={handleChange}
              value={data && data.altPhoneNumber}
            />
          </InputGroup>
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="email">
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email address"
            onChange={handleChange}
            value={data && data.email}
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="address">
          <Form.Label>Address</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter address"
            onChange={handleChange}
            value={data && data.address}
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="state">
          <Form.Label>State</Form.Label>
          <SelectDropdown
            searchable={true}
            clearButton={true}
            options={states}
            labelField="state"
            valueField="state"
            placeholder="Please select"
            searchPlaceholder="Search..."
            selectedValue={data && data.state}
            onSelect={(value) => {
              setData({ ...data, state: value });
              getCityByState(value);
            }}
            menuClass="shadow"
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="city">
          <Form.Label>City</Form.Label>
          <SelectDropdown
            searchable={true}
            clearButton={true}
            options={cities}
            labelField="name"
            valueField="name"
            placeholder="Please select"
            searchPlaceholder="Search..."
            selectedValue={data && data.city}
            onSelect={(value) => setData({ ...data, city: value })}
            menuClass="shadow"
          />
        </Form.Group>
      </div>

      <div className='py-3 mt-3'>
        <h6>Lead Status</h6>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="source">
          <Form.Label>Status *</Form.Label>
          <SelectDropdown
            searchable={false}
            options={[
              { name: "New", value: "New" },
              { name: "Contacted", value: "Contacted" },
              { name: "Site Visit Done", value: "Site Visit Done" },
              { name: "Converted", value: "Converted" },
              { name: "Lost", value: "Lost" }
            ]}
            labelField="name"
            valueField="value"
            placeholder="Please Select"
            selectedValue={data && data.status}
            onSelect={(value) => setData({ ...data, status: value })}
            menuClass="shadow"
            leftComponent={<h5>0</h5>}
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="source">
          <Form.Label>Source</Form.Label>
          <SelectDropdown
            searchable={false}
            clearButton={true}
            options={[
              { name: "Phone Calls", value: "Phone Calls" },
              { name: "Social Media", value: "Social Media" },
              { name: "Referral Sites", value: "Referral Sites" }
            ]}
            labelField="name"
            valueField="value"
            placeholder="Please Select"
            selectedValue={data && data.source}
            onSelect={(value) => setData({ ...data, source: value })}
            menuClass="shadow"
          />
          <Form.Control.Feedback type="invalid">{inputError && inputError.source}</Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="propertyType">
          <Form.Label>Property Type</Form.Label>
          <SelectDropdown
            searchable={false}
            options={[
              { name: "Building", value: "Building" },
              { name: "Land", value: "Land" }
            ]}
            labelField="name"
            valueField="value"
            placeholder="Please Select"
            selectedValue={data && data.propertyType}
            onSelect={(value) => setData({ ...data, propertyType: value, interestedProject: null })}
            menuClass="shadow"
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="interestedProject">
          <Form.Label>Interested Project</Form.Label>
          <SelectDropdown
            searchable={false}
            clearButton={true}
            options={filteredProperties}
            labelField="name"
            valueField="id"
            placeholder="Please Select"
            selectedValue={data && data.interestedProject && data.interestedProject.propertyName}
            onSelect={(value) => {
              const obj = properties.find(x => x.id === value);
              setData({ ...data, interestedProject: { propertyName: obj.name, id: obj.id } });
            }}
            menuClass="shadow"
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="budgetRange">
          <Form.Label>Budget Range</Form.Label>
          <SelectDropdown
            searchable={false}
            clearButton={true}
            options={[
              { label: "₹5 Lakh - ₹25 Lakh", value: "₹5 Lakh - ₹25 Lakh" },
              { label: "₹25 Lakh - ₹50 Lakh", value: "₹25 Lakh - ₹50 Lakh" },
              { label: "₹50 Lakh - ₹1 Crore", value: "₹50 Lakh - ₹1 Crore" },
              { label: "₹1 Crore - ₹2 Crore", value: "₹1 Crore - ₹2 Crore" },
              { label: "₹2 Crore - ₹5 Crore", value: "₹2 Crore - ₹5 Crore" },
              { label: "₹5 Crore and above", value: "₹5 Crore and above" }
            ]}
            labelField="label"
            valueField="value"
            placeholder="Please Select"
            selectedValue={data && data.budgetRange}
            onSelect={(value) => setData({ ...data, budgetRange: value })}
            menuClass="shadow"
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="timeline">
          <Form.Label>Timeline to Purchase</Form.Label>
          <SelectDropdown
            searchable={false}
            clearButton={true}
            options={[
              { label: "Immediately", value: "Immediately" },
              { label: "1-3 Months", value: "1-3 Months" },
              { label: "3-6 Months", value: "3-6 Months" },
              { label: "6+ Months", value: "6+ Months" },
              { label: "No Specific Time", value: "No Specific Time" },
            ]}
            labelField="label"
            valueField="value"
            placeholder="Please Select"
            selectedValue={data && data.timeline}
            onSelect={(value) => setData({ ...data, timeline: value })}
            menuClass="shadow"
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="visibility">
          <Form.Label>Visibility</Form.Label>
          <SelectDropdown
            searchable={false}
            options={[
              { label: "Public", value: "Public" },
              { label: "Private", value: "Private" }
            ]}
            labelField="label"
            valueField="value"
            placeholder="Please Select"
            selectedValue={data && data.visibility}
            onSelect={(value) => setData({ ...data, visibility: value })}
            menuClass="shadow"
          />
        </Form.Group>
      </div>
      <div className='col-md-6'>
        <Form.Group className="mb-3" controlId="assignedTo">
          <Form.Label>Assigned To</Form.Label>
          <SelectDropdown
            searchable={true}
            clearButton={true}
            options={[
              { label: "Agent Name", value: "Agent Name" }
            ]}
            labelField="label"
            valueField="value"
            placeholder="Please Select"
            searchPlaceholder="Search..."
            selectedValue={data && data.assignedTo}
            onSelect={(value) => setData({ ...data, assignedTo: value })}
            menuClass="shadow"
          />
        </Form.Group>
      </div>
      <div className='col-md-12'>
        <Form.Group className="mb-3" controlId="notes">
          <Form.Label>Notes</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder="Enter notes..."
            onChange={(event) => setNoteData({ ...noteData, note: event.target.value })}
            value={noteData && noteData.note}
          />
        </Form.Group>
      </div>
    </div>
  )
}

export default LeadForm;
